// extracted by mini-css-extract-plugin
export default {"bloc":"zpu4st1hAePU_4N_XPR8","outline":"az9Wb9emY1k3A2eajwDg","blocHeader":"Epghni5vA_fWY5zNuW_N"};